<template>
  <v-dialog v-model="show" persistent max-width="90vw" max-height="90vh">
    <v-card class="photo-gallery-modal-card">
      <v-card-title class="defect-details">
        <v-row v-if="currentPhoto">
          <v-col cols="2">
            <strong>EDN:</strong> {{ currentPhoto.defect.ednNumber }}
          </v-col>
          <v-col cols="3">
            <strong>Description:</strong> {{ currentPhoto.defect.description }}
            <span v-if="currentPhoto.defect.notes"> // {{ currentPhoto.defect.notes }}</span>
          </v-col>
          <v-col cols="2">
            <strong>Received:</strong> {{ moment(currentPhoto.defect.receivedDate).format(dateFormat) }}
          </v-col>
          <v-col cols="2">
            <strong>Completed:</strong> {{ moment(currentPhoto.defect.completedDate).format(dateFormat) }}
          </v-col>
          <v-col cols="2">
            <strong>By:</strong> {{ currentPhoto.defect.completedBy || 'N/A' }}
          </v-col>
          <v-col cols="1">
            {{ currentIndex + 1 }} of {{ photos.length }}
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="photo-gallery-modal-content">
        <div class="photo-gallery-container">
          <!-- Navigation arrows -->
          <v-btn
            v-if="photos.length > 1"
            icon
            large
            class="nav-btn nav-btn-left"
            @click="previousPhoto"
            :disabled="currentIndex === 0"
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <v-btn
            v-if="photos.length > 1"
            icon
            large
            class="nav-btn nav-btn-right"
            @click="nextPhoto"
            :disabled="currentIndex === photos.length - 1"
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>

          <!-- Main photo display -->
          <div v-if="currentPhoto" class="photo-display">
            <v-img
              :src="currentPhoto.photoUrl"
              contain
              class="photo-image"
            />
          </div>

          <!-- No photos message -->
          <div v-else class="no-photos-message">
            <v-icon large>mdi-image-off</v-icon>
            <p>No photos available</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="photo-gallery-modal-actions">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="downloadPhoto">
          <v-icon left>download</v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="close">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DateFormat } from '@/plugins/date-filter';

export default {
  name: 'PhotoGalleryModal',
  props: {
    photos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      show: false,
      currentIndex: 0,
      dateFormat: DateFormat.DefaultDisplay
    };
  },
  computed: {
    currentPhoto() {
      return this.photos[this.currentIndex] || null;
    }
  },
  methods: {
    showModal() {
      this.show = true;
      this.currentIndex = 0;
      this.addKeyboardListeners();
    },
    close() {
      this.show = false;
      this.removeKeyboardListeners();
      this.$emit('closed');
    },
    nextPhoto() {
      if (this.currentIndex < this.photos.length - 1) {
        this.currentIndex++;
      }
    },
    previousPhoto() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    downloadPhoto() {
      if (!this.currentPhoto) {
        return;
      }

      const link = document.createElement('a');
      link.href = this.currentPhoto.photoUrl;
      link.download = `defect-photo-${this.currentPhoto.defect.ednNumber}-${Date.now()}.jpg`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleKeydown(event) {
      if (!this.show) {
        return;
      }

      switch (event.key) {
        case 'ArrowLeft':
          this.previousPhoto();
          break;
        case 'ArrowRight':
          this.nextPhoto();
          break;
        case 'Escape':
          this.close();
          break;
      }
    },
    addKeyboardListeners() {
      document.addEventListener('keydown', this.handleKeydown);
    },
    removeKeyboardListeners() {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.currentIndex = 0;
      }
    }
  },
  beforeDestroy() {
    this.removeKeyboardListeners();
  }
};
</script>

<style scoped>
.photo-gallery-modal-card {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.photo-gallery-modal-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.photo-gallery-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-display {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-image {
  max-width: 100%;
  max-height: 100%;
}

.nav-btn {
  position: absolute;
  top: 50%;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8) !important;
}

.nav-btn-left {
  left: 16px;
}

.nav-btn-right {
  right: 16px;
}

.defect-details {
  background-color: rgb(55, 87, 56);
  font-size: 15px;
  color: white;
}

.defect-details .v-row {
  margin: 0;
}

.defect-details .v-col {
  padding: 4px 8px;
}

.photo-gallery-modal-actions {
  padding: 16px;
  border-top: 1px solid #e0e0e0;
}

.no-photos-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
}

.no-photos-message p {
  margin-top: 16px;
  font-size: 16px;
}
</style>
